"use strict";
const PIXELS_PER_LEVEL = 22 * window.devicePixelRatio;
const MUTE_THRESHOLD = 10 * window.devicePixelRatio;
const HIDE_THRESHOLD = 0.5 * window.devicePixelRatio;
const LABEL_THRESHOLD = 20 * window.devicePixelRatio;
const BAR_BORDER_WIDTH = 0.5 * window.devicePixelRatio;
const BAR_TEXT_PADDING_LEFT = 4 * window.devicePixelRatio;
const GROUP_STRIP_WIDTH = 3 * window.devicePixelRatio;
const GROUP_STRIP_PADDING = 3 * window.devicePixelRatio;
const GROUP_STRIP_MARGIN_LEFT = 4 * window.devicePixelRatio;
const GROUP_TEXT_OFFSET = 2 * window.devicePixelRatio;
const MIN_WIDTH_TO_SHOW_BOTH_TOPTABLE_AND_FLAMEGRAPH = 800;
const TOP_TABLE_COLUMN_WIDTH = 120;

export { BAR_BORDER_WIDTH, BAR_TEXT_PADDING_LEFT, GROUP_STRIP_MARGIN_LEFT, GROUP_STRIP_PADDING, GROUP_STRIP_WIDTH, GROUP_TEXT_OFFSET, HIDE_THRESHOLD, LABEL_THRESHOLD, MIN_WIDTH_TO_SHOW_BOTH_TOPTABLE_AND_FLAMEGRAPH, MUTE_THRESHOLD, PIXELS_PER_LEVEL, TOP_TABLE_COLUMN_WIDTH };
//# sourceMappingURL=constants.mjs.map
